<h1 mat-dialog-title>{{dataDialog.title}}</h1>
<div mat-dialog-content>
    <p [innerHtml]="dataDialog.message"></p>
</div>
<div mat-dialog-actions>
    <button cdkFocusInitial class="btn btn-success" (click)="dialogRef.close(true)">Accept</button>
    <button style="margin-left: 20px" (click)="dialogRef.close(false)" class="btn btn-danger">Cancel</button>
</div>